module.exports = __webpack_public_path__ + "./Lina_color_b55c62b1eb43c2b007d8dc8c871ccae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Lina_color.jpg
// module id = 598
// module chunks = 0